import { initAwsRum } from 'odc-shared/utils/initAwsRum';
import ReactDOM from 'react-dom/client';

import App from './App';
import { awsRumConfig } from './config/env.config';
import { normalizeHelpCenterUrl, setupHelpCenterI18n } from './i18n';

// 初始化帮助中心 i18n（必须在渲染前完成；key 即英文原文，未命中的 key 展示英文原文）：
// 先把"上次选择"补进 URL（仅帮助中心内页），再按 URL 初始化 —— 首帧语言就是对的，不会闪。
// 刻意不用 odc-shared 的 initI18n，避免与同域「变现端」的 odc_language 互相影响。
normalizeHelpCenterUrl();
setupHelpCenterI18n();

if (awsRumConfig.identityPoolId && awsRumConfig.applicationId) {
  initAwsRum({
    identityPoolId: awsRumConfig.identityPoolId,
    applicationId: awsRumConfig.applicationId,
  });
}
async function main() {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(<App />);
}
main();